import { render, staticRenderFns } from "./FilterControl.vue?vue&type=template&id=672e40e4&"
import script from "./FilterControl.vue?vue&type=script&lang=js&"
export * from "./FilterControl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports